import { Box, Pagination } from "@mui/material";

function CardPagination(props: {count:number,page:number,setPage:React.Dispatch<React.SetStateAction<number>>}): JSX.Element {
  //LeftDrawerの設定
    const {
        count,
        page,
        setPage
    } = props

    return (
        <>
            <Box
            marginTop="10px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            >
                <Pagination
                    count={count}
                    page={page}
                    onChange={(e, page) =>setPage(page)}
                />
            </Box>
        </>
      );
};
export default CardPagination;
